import AntIcon from "@/components/icons/AntIcon";
import { InputNumber } from "@/components/InputNumber";
import { formatLocaleCurrency } from "@/utils/formatUtils";
import { isDefined } from "@/utils/utils";
import { NamePath } from "@rc-component/form/es/interface";
import { Flex, Form, Popover } from "antd";
import type { Rule } from "antd/es/form";
import type { ReactNode } from "react";
import { CalcCheckableTag } from "./CalcCheckableTag";

type Props = {
  name: NamePath;
  amountName: NamePath;
  label: string;
  amountLabel: ReactNode;
  rules?: Rule[];
  step?: number;
};

export const CalcAmountTag = ({ name, amountName, label, amountLabel, rules, step }: Props) => {
  const form = Form.useFormInstance();
  const checked = Form.useWatch(name, form);
  const amount = Form.useWatch(amountName, form);

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      content={
        <Flex vertical gap="small" style={{ minWidth: 200 }}>
          <Form.Item name={amountName} label={amountLabel} rules={rules} style={{ marginBottom: 0 }}>
            <InputNumber addon="euro" step={step} onChange={(value) => form.setFieldValue(name, isDefined(value))} />
          </Form.Item>
        </Flex>
      }
    >
      <CalcCheckableTag checked={!!checked}>
        {checked && isDefined(amount) ? `${label}: ${formatLocaleCurrency(amount, 0)}` : label}
        <AntIcon type="down" style={{ marginLeft: 6, fontSize: 10 }} />
      </CalcCheckableTag>
    </Popover>
  );
};
